import React from "react";
import Home from "./Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import BlogPage from "./BlogPage";

const RoutesComponents = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Blog" element={<BlogPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RoutesComponents;
